<script>
export default {
  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  methods: {
    async checkFeature(featureSlug) {
      return await this.$store.dispatch("feature_flags/check", featureSlug);
    },
  },

  computed: {},
};
</script>
